import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9dc9624"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "place-list" }
const _hoisted_2 = { class: "has-text-modest level-center is-mobile" }
const _hoisted_3 = { class: "level-left is-mobile" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(null) + " ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppIconPlaces = _resolveComponent("AppIconPlaces")!
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_AppLabelPlaces = _resolveComponent("AppLabelPlaces")!
  const _component_ButtonIcon = _resolveComponent("ButtonIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.places, (place) => {
        return (_openBlock(), _createElementBlock("li", {
          key: place.value
        }, [
          _createVNode(_component_AppLabelPlaces, {
            fill: _ctx.values.includes(place.value),
            type: _ctx.values.includes(place.value) ? place.value : 'forbidden',
            class: "has-background-modest"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AppCheckbox, {
                id: `place-list-${place.value}`,
                modelValue: _ctx.values,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.values) = $event)),
                value: place.value
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_AppIconPlaces, {
                    type: place.value
                  }, null, 8, ["type"]),
                  _createTextVNode(" " + _toDisplayString(place.label), 1)
                ]),
                _: 2
              }, 1032, ["id", "modelValue", "value"])
            ]),
            _: 2
          }, 1032, ["fill", "type"])
        ]))
      }), 128)),
      _createElementVNode("li", _hoisted_3, [
        _createVNode(_component_router_link, { to: {hash: '#top-page-site-guidance'} }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createVNode(_component_ButtonIcon, {
              id: "button-questionmark--sp",
              icon: "circle-questionmark",
              styled: "is-none",
              text: _ctx.$t('rekionGuidance.title'),
              class: "is-hidden-desktop",
              tabindex: "-1"
            }, null, 8, ["text"]),
            _createVNode(_component_ButtonIcon, {
              id: "button-questionmark--pc",
              icon: "circle-questionmark",
              styled: "is-none",
              class: "is-hidden-mobile",
              "aria-label": _ctx.$t('rekionGuidance.title'),
              tabindex: "-1"
            }, null, 8, ["aria-label"])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}